import { CSearchShipmentForInvoiceResponseType } from "../types";

export class CSearchShipmentForInvoiceResponse implements CSearchShipmentForInvoiceResponseType {
  constructor(json: CSearchShipmentForInvoiceResponseType) {
    Object.assign(this, json);
  }

  data: {
    bookingId?: string | undefined;
    shipmentId?: string | undefined;
    destinationCountryCode: string;
    destinationCountryFlagLink: string;
    destinationPort: string;
    matchedNumber: string;
    originCountryCode: string;
    originCountryFlagLink: string;
    originPort: string;
    tag: string;
    type: string;
  }[];
}